let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8z6OY")).then(() => parcelRequire('8Z6uP'));